module.exports = __webpack_public_path__ + "static/hush_emoji-7ca00ce6b296508c56f5f1b25e102f16.svg";